import React, { FC, useContext, useEffect, useRef, useState } from "react";
//import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";


// import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
// import Avatar from "./Avatar";
// import FooterNav from "components_custom/FooterNav/FooterNav";
import { useNavigate } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { ArrowSmallLeftIcon, PhotoIcon } from "@heroicons/react/24/outline";
import { GlobalDataContext } from "contexts/GlobalData";
import { requestAPI } from "utils/api";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}


// const Logo = () => (
// 	<svg className="icon" x="0px" y="0px" viewBox="0 0 24 24">
// 	  <path fill="transparent" d="M0,0h24v24H0V0z"/>
// 	  <path fill="#000" d="M20.5,5.2l-1.4-1.7C18.9,3.2,18.5,3,18,3H6C5.5,3,5.1,3.2,4.8,3.5L3.5,5.2C3.2,5.6,3,6,3,6.5V19  c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V6.5C21,6,20.8,5.6,20.5,5.2z M12,17.5L6.5,12H10v-2h4v2h3.5L12,17.5z M5.1,5l0.8-1h12l0.9,1  H5.1z"/>
// 	</svg>
//   );
  
//   const FileInfo = ({ uploadedInfo }: any) => (
// 	<ul className="preview_info">
// 	  {Object.entries(uploadedInfo).map(([key, value]) => (
// 		<li key={key}>
// 		  <span className="info_key">{key}</span>
// 		  <span className="info_value">value</span>
// 		</li>
// 	  ))}
// 	</ul>
//   );


const ModifyAvatarImg: FC<SectionLatestPostsProps> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {

	const buttonRef = useRef (null);

	const navigate = useNavigate ();

	const { 
		initData,
		setInitData,
	} = useContext (GlobalDataContext);

	const [isActive, setActive] = useState(false);
	const [uploadedInfo, setUploadedInfo] = useState <any> ({});
	const [postImg, setPostImg] = useState([]);
	const [previewImg, setPreviewImg] = useState("");
	const [imgData, setImgData] = useState<any>(null);
    
	function uploadFile(e: any) {
		
	};

	useEffect(()=>{
		
		if (initData.token_info.permission_group === "guest") {

			navigate('/me')	
		}	
		
	}, []);


	const handleSubmit = async () => {
		const _initData = {...initData};
		const _id = _initData.userInfo._id;

		const formData = new FormData();

		const file = imgData.name.split('.');
		const newFileName = `${_id}_logo.${file[file.length-1]}`;

        formData.append("file", imgData, newFileName);

        	
		

		//formData.append("data", JSON.stringify(value)); // JSON 형식으로 파싱.(백엔드의 요청에 따라 전송방식이 달라진다.)
		//const formData = new FormData();
		//const blob = new Blob([imgData], { type: "image/png" });
		//console.log(blob)
		//formData.append('swimArea', new Blob([JSON.stringify(swimArea)], { type: "application/json" }));
		//formData.append("file", blob)
		// const blob2 = new Blob([JSON.stringify(value)], {type: "application/json"}) 
		// formData.append("data",blob2);
		;
		

		//const res_info: any = await requestAPI ('FILE', `v1/user/${_id}/license`, formData);
		const res_upload: any = await requestAPI ('FILE', `profile`, formData);

		if (res_upload.code === 1000) {
			
			console.log('성공');
			
			const res_info: any = await requestAPI ('PUT', `v1/user/${_id}/profileimg`, {
				fileName: newFileName
			});

			_initData.userInfo = res_info.data.userInfo;
			setInitData(_initData);
			navigate('/me');
			
		} else if (res_upload.code === 4000) {
			console.log('실패');
		}
	};
	
	const handleCancel = () => {
		navigate(-1);
	};


	const setFileInfo = (file: any) => {
		const { name, size: byteSize, type } = file;
		const size = (byteSize / (1024 * 1024)).toFixed(2) + 'mb';
		
		setUploadedInfo({ name, size, type }); // name, size, type 정보를 uploadedInfo에 저장
	};

	//   const handleDragStart = () => setActive(true);
	//   const handleDragEnd = () => setActive(false);
	//   const handleDragOver = (event: any) => {
	// 	event.preventDefault();
	//   };
	//   const handleDrop = (event: any) => {
	// 	event.preventDefault();
	// 	setActive(false);
	
	// 	const file = event.dataTransfer.files[0];
	// 	setFileInfo(file);
	//   };
	
	const handleUpload = (e : any) => {

		let fileArr = e.target.files;
		let fileRead: any = new FileReader();

		setPostImg(Array.from(fileArr));
		setFileInfo(fileArr[0]);
    	
		fileRead.onload = function(){
			setPreviewImg(fileRead.result);
			
			
		};
		
		fileRead.readAsDataURL(fileArr[0]);

		setImgData(fileArr[0]);
		

	};

	const handleBack = () => {
		navigate(-1);
	}

	return (
		<>
			
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>

				<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
					<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
						<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
							<button
								className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
								onClick={()=> handleBack()}
							>
								<ArrowSmallLeftIcon className="w-6 h-6" />
							</button>
							{/* <LikeSaveBtns /> */}
							<span
								className="text-xl"
							>
								뒤로
							</span>
						</div>
					</div>
				</div>
				
				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">
						<div className="mt-5" />
						<div
							className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
							>
							<div
								className={`max-w-2xl`}
							>
								<h2 className={`text-3xl md:text-4xl font-semibold`}>
									프로필 이미지 수정
								</h2>
							</div>
						</div>

						<div className="mt-10" />
						
						<div>
							<span
								className="text-xl font-semibold text-slate-600"
							>
								변경하실 프로필 이미지를 올려주세요
							</span>
						</div>
						<div>
							<span 
								className="text-sm text-slate-600"
							>
								{(initData.userInfo.licenseUrl === "" || initData.userInfo.licenseUrl === undefined || initData.userInfo.licenseUrl === null)
									? "현재 등록된 프로필 사진이 없어요." 
									: `등록된 프로필 사진이 있어요`
								}
							</span>
						</div>

						<div className="mt-10" />

						<div className="mt-10 md:ml-10 md:mr-10">
							<div>
								{Object.keys(uploadedInfo).length === 0
									? 
										<div className={`flex justify-center items-end w-full`}>
											<div className="w-full">
												<div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10">
													<div className="text-center">
														<PhotoIcon aria-hidden="true" className="mx-auto h-12 w-12 text-gray-300" />
														<div className="mt-4 text-sm leading-6 text-gray-600">
															<label
																htmlFor="test"
																className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
																
															>
																<span>Upload a file</span>
																<input 
																	id="test" 
																	name="attachment" 
																	type="file" 
																	className="sr-only"
																	onChange={handleUpload}
																	
																/>
															</label>
														</div>
														<p className="text-xs leading-5 text-gray-600">PNG, JPG, GIF up to 10MB</p>
													</div>
												</div>
											</div>
										</div>
									: 
										<div className="w-full">
											<div className="flex items-center justify-center">
												<img src={previewImg} className="object-cover h-[300px]" />
											</div>
											<div className="flex flex-col mt-12 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
												<ButtonSecondary
													onClick={() => handleCancel()}
												>
													취소
												</ButtonSecondary>
												<ButtonPrimary
													onClick={() => handleSubmit()}
												>
													수정
												</ButtonPrimary>
											</div>				
										</div>		
								}
							</div>

							
						</div>
					</div>

				</div>
				
			</div>
		</>
	);
};

export default ModifyAvatarImg;
